// ----------------------------------------------------------------------------
// Template: Blog
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/pagination/pagination';
import 'sections/page-header/page-header';
import 'sections/blog-posts/blog-posts';
import 'sections/footer/footer';

import $ from 'jquery';

// Styles
import './_blog.scss';


$(function() {

/**
 * Wrap Youtube iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 */
    $(".blog-article__content").find('iframe[src*="youtube.com"]').each(function() {
        $(this).wrap( "<div class='rte__video-wrapper'></div>" );
    }); 
    
});


